import APIService from "../components/postServices";
import { showToast } from "../components/toastServices";
import { useReducer } from "react";

const initialState = {
  data: [],
  idx: -1,
};

function reducer(state, action) {
  let newState;
  switch (action.type) {
    case "list":
      newState = {
        data: action.payload,
        // idx: action.payload.length > 0 ? 0 : -1,
      };
      return newState;

    default:
      throw new Error();
  }
}

export function useDataApi() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const dataList = (value) => {
    // Fetch data when the component mounts
    APIService.get(value)
      .then((response) => {
        if (response.status === 200) {
          dispatch({ type: "list", payload: response.data.dataSet });
        } else {
          showToast("error", response.data.responseMessage);
        }
      })
      .catch((error) => {
        // Handle API call errors here
        showToast("error", error);
      });
  };

  return [state, dataList];
}
